<section class="images-slider-tile">
  <div class="slide-image-wrap">
    <button class="close-btn" (click)="close()">
      <i class="icon icon-Plus_ico"></i>
    </button>

    <div class="slide-btn-section left">
      <button class="slide-btn btn-prev" *ngIf="currentIndex > 0" (click)="prev()">
        <i class="icon icon-Arrow_v2_ico icon-arrow-btn"></i>
      </button>
    </div>

    <div *ngIf="collection.loading$ | async">
      <loader [loading]="collection.loading$"></loader>
    </div>

    <ng-container *ngIf="collection.items[currentIndex]">
      <img
        class="image"
        imageFallback="/assets/img/img-placeholder.png"
        src="{{
          collection.items[currentIndex]?.link
            ? collection.items[currentIndex]?.link
            : unsupportedImageTypes.includes(collection.items[currentIndex].type.toLowerCase())
              ? 'assets/img/img-placeholder.png'
              : collection.items[currentIndex]?.file_url
        }}" />
    </ng-container>

    <div class="slide-btn-section right">
      <button class="slide-btn btn-next" *ngIf="currentIndex < collection.items.length - 1" (click)="next()">
        <i class="icon icon-Arrow_v2_ico icon-arrow-btn"></i>
      </button>
    </div>
  </div>

  <div class="image-info-wrap">
    <div class="image-info">
      <div *ngIf="isDeleteShown" class="delete-btn">
        <btn-action
          [buttonLabel]="'Delete' | translate"
          [withIcon]="true"
          iconClass="icon-Delete_ico"
          (applyAction)="deleteAction()"
          styleClasses="delete">
        </btn-action>
      </div>

      <ng-container *ngIf="collection.items[currentIndex] && collection.items[currentIndex]['created_at']">
        <div class="info-block">
          <div class="info-block--title" translate>Uploaded:</div>

          <div class="info-block--value">
            {{ getTimeFormat }}
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="collection.items[currentIndex] && collection.items[currentIndex]['created_by']">
        <div class="info-block">
          <div class="info-block--title" translate>Created by:</div>

          <div class="info-block--value">
            {{ collection.items[currentIndex]['created_by'] }}
          </div>
        </div>
      </ng-container>
    </div>

    <div
      class="preview-images"
      infinite-scroll
      [infiniteScrollContainer]="'.preview-images'"
      [fromRoot]="true"
      [infiniteScrollDistance]="1"
      [infiniteScrollUpDistance]="2"
      [infiniteScrollThrottle]="30"
      (scrolled)="onScroll()">
      <div class="loader-wrap" *ngIf="collection.loading$ | async">
        <loader [loading]="collection.loading$"></loader>
      </div>
      <ng-container *ngIf="item">
        <ng-container *ngFor="let image of collection.items; let i = index">
          <div class="image-wrap" (click)="selectImage(i)" [class.active]="currentIndex === i">
            <img
              class="image"
              imageFallback="/assets/img/img-placeholder.png"
              [src]="
                image?.link
                  ? image?.link
                  : unsupportedImageTypes.includes(image.type.toLowerCase())
                    ? 'assets/img/img-placeholder.png'
                    : image?.file_url
              " />
          </div>
        </ng-container>
      </ng-container>

      <ng-container *ngIf="!item">
        <ng-container *ngFor="let image of collection.items; let i = index">
          <div class="image-wrap" (click)="selectImage(i)" [class.active]="currentIndex === i">
            <img class="image" [src]="image?.link || image?.file_url" />
          </div>
        </ng-container>
      </ng-container>
    </div>
  </div>
</section>
